import React, { useState } from "react";
import june from '../img/1june.jpg';
import masterv from '../img/masterv.jpeg';
import onejune from '../img/1june24.jpeg';
import june24 from '../img/profjune24.jpeg';
import opend from '../img/foropen.jpeg';
import reading from '../img/reading.jpg';
import game from '../img/game.jpg';
import dancing from '../img/dancing.jpg';
import prodlenka from '../img/prodlenka.jpeg';
import pianoNews from '../img/pianoNews.jpg';
import schoolLeader2024 from '../img/schoolLeader2024.jpg';
import teenSTARtup from '../img/teenSTARtup.jpg';
import piter from '../img/piter.jpg';
import rost from '../img/rost.jpg';
import lekciya from '../img/lekciya.jpg';
import avtorAnna from '../img/avtorAnna.jpg';
import otec from '../img/otec2026.jpg'
import './images.css';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('Все категории');
  const [searchKeyword, setSearchKeyword] = useState('');

  const posts = [
    {
      id: 1,
      image: otec,
      title: "Роль отца в жизни ребёнка — это фундамент!",
      text: "Отец даёт ребёнку чувство защищённости, уверенности и здоровую самооценку. Психологи подтверждают: присутствие папы с раннего возраста формирует стабильность и поддержку, помогая малышу расти самостоятельным и ответственным.",
      textNext: "Когда оба родителя рядом, дети лучше адаптируются, становятся эмоционально устойчивыми и справляются с трудностями. Не упускайте шанс быть частью этого! ❤️",
      texts: "Мультиформатный центр «Форматы» приглашает на занятия к детскому психологу: Развитие здоровых семейных отношений; Решение вопросов воспитания; Поддержка для родителей и детей любого возраста.Запись по телефону: +7 (992) 300-65-23",
      category: { label: "Связаться с нами", labelTwo: "Взрослые Форматы", href: "/contact" },
    },
    {
      id: 2,
      image: rost,
      title: "Разбирайтесь в людях: офлайн-тренинг по типологии личности.",
      text: "Хотите лучше понимать людей, строить продуктивные отношения и избегать конфликтов? Мы научим вас анализировать поведение людей, считывать их мотивацию и прогнозировать реакции.",
      textNext: "📍 Формат тренинга: 1. Живое общение, работа в группе; 2. Интерактивные упражнения и разбор реальных ситуаций. 3. Авторская методика, основанная на 6-летнем опыте.",
      texts: "📌 Что вы получите на тренинге? ✅ Освоите базовые психотипы личности ✅ Поймёте, как правильно доносить свои мысли ✅ Разберётесь, почему вас могут не понимать на работе или в семье" + 
      "✅ Научитесь определять ключевые мотивы людей ✅ Получите рабочие тетради и практический инструментарий. Это живое мероприятие, где вы сразу сможете применить знания и потренироваться на реальных примерах." + 
      " 🎁 Бонус: рабочие материалы, лёгкий фуршет, ответы на все ваши вопросы. Места ограничены. Запись по телефону.",
      category: { label: "Связаться с нами", labelTwo: "Взрослые Форматы", href: "/contact" },
    },
    {
      id: 3,
      image: piter,
      title: "Каникулы в Санкт-Петербурге!",
      text: "Предлагаем незабываемый тур в Санкт-Петербург, который подарит вам и вашим детям яркие впечатления, новые знания и теплые воспоминания. Стоимость зависит от варианта размещения – количество мест ограничено!",
      category:  { label: "Путешествие", labelTwo: "Детские Форматы", href: "/vacation" },
    },
    {
      id: 4,
      image: teenSTARtup,
      title: "БИЗНЕС КЛУБ для подростков “STARtup”",
      text: "Прокачай свою личность! Нестандартный подход и максимальная польза для развития и уверенности в себе. Занятость: 1-2 раза в неделю. Занятие 1,5 часа. Расписание занятий и подробности по телефону: +7 (992) 300-65-23, +7 (992) 300-65-46.",
      category: { label: "Детские Форматы", href: "/prof" },
    },
    {
      id: 5,
      image: prodlenka,
      title: "В нашем центре есть 1 и 2 смена на продленке.",
      text: "У нас Развивающие занятия, Питание 2 раза (завтрак/полдник и комплексный обед), Забираем/отводим детей с/в ближайших(-ие) школ(-ы), Помощь в подготовке домашних заданий, Прогулка (зависит от погодных условий).",
      category: { label: "Детские Форматы", href: "/afterschool" },
    },
    {
      id: 6,
      image: dancing,
      title: "НОВОЕ НАПРАВЛЕНИЕ - ХОРЕОГРАФИЯ",
      text: "У нас новое напрвление - хореография. Приходите и узнаете больше! С лучшим педагогом Ириной Николаевной.",
      category:  { label: "Детские Форматы", href: "/contact" },
    },
    {
      id: 7,
      image: opend,
      title: "В нашем Центре развития «Форматы» 1 раз в квартал проходит День открытых дверей",
      text: "Такие как профессиональные мастер-классы, конкурсы, участие с родителями, сладкие подарки. Тематика и формат событий отличаются друг от друга! Приходите и проведите день с пользой для себя и ребенка! Дополнительная информация по номеру: +7 (992) 300-65-46, + 7(992) 300-65-23 Адрес: ул.Попова, 7, стр.2 (вход с торца)",
      category: { label: "Связаться с нами", href: "/contact" },
    },
    {
      id: 8,
      image: pianoNews,
      title: "Наборы на музыкальное направление Фортепиано и Скрипка",
      text: "Запишитесь к нам на пробное занятие и выберите удобный график. Наш педагог поможет вам освоить базовые навыки игры на пианино и даст необходимые советы по технике исполнения.",
      category: { label: "Детские Форматы", href: "/music" },
    },
    {
      id: 9,
      image: reading,
      title: "Научись читать за 10 занятий для детей от 5+",
      text: "Сейчас самое время! Логопед. Каллиграфия. Скорочтение.",
      category:  { label: "Детские Форматы", href: "/logoped" },
    },
    {
      id: 10,
      image: masterv,
      title: "Ежемесячно по выходным в нашем центре проводятся разные полезные авторские мастер-классы для детей и взрослых.",
      text: "Направления: Рисование, Макраме, Вязание, Плетение бисером, Изготовление снудов и шапок из пуффи,  декупаж и не только, а также конкурсы, участие с родителями, сладкие подарки. Тематика и формат событий отличаются друг от друга! Приходите и проведите день с пользой для себя и ребенка!",
      category: { label: "Детские Форматы", href: "/class" },
    },
    {
      id: 11,
      image: avtorAnna,
      title: "Тренинг с элементами коучинга. «Я ВЫБИРАЮ СЕБЯ!» или «Как полюбить себя» ",
      text: "📅  Дата:  28 июня 2025. 🕑 Время: 14:00–17:00. Вы знали, что женщина в развитии — это источник энергии и счастья? Я приглашаю вас на трансформационный тренинг с элементами коучинга, где мы разберем самое важное — ВАС! Твоя жизнь - твои правила! ",
      bulletPoints: [
        "Почему всё идёт не так, как хочется? А что на самом деле хочется?",  
        "Как запустить внутренние перемены?", 
        "Что подрывает самооценку и как её восстановить?",  
        "Как реагировать, когда что-то идёт не по плану?",  
        "Как поддерживать себя и не терять мотивацию?",  
        "Как держать личные границы и научиться  говорить « нет» ?",  
        "Что мешает двигаться вперёд?",  
        "Как выйти из хаоса и стать счастливой?",
        "Как найти свой путь к гармонии и балансу?",  
      ],
      textNext:"📌 Расписание мероприятия:  ✅ 13:45 - 13:55 – Регистрация участников; ✅ 14:00 - 15:10 – Хватит терпеть! Время полюбить себя: самооценка, границы, баланс и гармония. Спикер: Анна Рублева – коуч-психолог, креативный руководитель центра «Форматы»" +
      "✅ 15:10 - 15:30 – Лёгкий фуршет с музыкальным сопровождением. 🥑 15:30 - 16:15 – Можно ли сохранить молодость и красоту естественным путём? Продукты вечной молодости. Подарок 🎁 ТОП-100 продуктов, богатых антиоксидантами." +
      "Спикер: Наталья Кекелия – практикующий нутрициолог, автор курсов, статей,спикер, ментор . ✅ 16:15 - 16:45– Секреты счастья. Практика.",
      texts: " Этот тренинг — ваш шаг к новой себе. Будет полезно, глубоко и вдохновляюще! Нельзя пропустить! Посещение платное, подробности и записаться необходимо: t.me/formatyou72; +7 (992)300-65-46",
      category: { label: "Связаться с нами", labelTwo: "Взрослые Форматы", href: "/contact" },
    },
    {
      id: 12,
      image: lekciya,
      title: "Лекция + практика «Взаимоотношения родители & дети. Как поддержать своего ребенка во время экзаменов?»",
      text: "📅 Встречаемся 17 мая 2025 в 🕑 12:00-14:00. Приглашаем вас на встречу с Рублевой Анной Владимировной - руководитель центра развития детей и взрослых. Нам важно учесть психологию воспитания и правильного развития." +
      " Дети растут, по статистике 50% на них влияет общество, 50% семья. Важно предвосхитить нежелательный сценарий будущего ребенка. Сформировать мотивацию и вовлеченность к учебе и работе." +
      " Посещение платное в формате доната от 500 рублей. Места ограничены, посещение по записи.",
      bulletPoints: [
        "Понимание детского восприятия",
        "Как поддержать вовремя",
        "Методы для мотивации дома",
        "Хитрости ребенка и эмоциональное состояние",
        "Поведение и критика",
      ],
      category:  { label: "Связаться с нами", labelTwo: "Детские Форматы", href: "/contact" },
    },
    {
      id: 13,
      image: game,
      title: "RELAX & GAME: игротехники и игропрактики для развития навыков soft skills",
      text: "СТАРТ ПРОГРАММЫ начался 5 АВГУСТА 2024!",
      category: { label: "Связаться с нами", href: "/contact" },
    },
    {
      id: 14,
      image: schoolLeader2024,
      title: "ШКОЛА ЛИДЕРСТВА 14+. ПРОКАЧАЙ СВОЮ ЛИЧНОСТЬ!",
      text: "Начало занятий 17.06.2024.",
      category:  { label: "Детские Форматы", href: "/prof" },
    },
    {
      id: 15,
      image: onejune,
      title: "1 ИЮНЯ — Детский ПРАЗДНИК во дворе вместе с командой Форматы!",
      text: "ФОРМАТЫ - это про ЛЮБОВЬ К РАЗВИТИЮ ДЕТЕЙ и ВЗРОСЛЫХ 💟 Время развлекаться пришло! Участвуй в локациях по выбору, получай отметки в КАРТЕ НАВИГАЦИИ и участвуй в РОЗЫГРЫШЕ призов от нас! Множество направлений как внутри так и снаружи центра для вас и ваших детей. Участие бесплатно! Регистрация обязательна по телефону: 8(992)300-65-46, 8(992)300-65-23",
      category:  { label: "Детские Форматы", href: "/vacation" },
    },
    {
      id: 16,
      image: june24,
      title: "Летняя Смена: Все профессии важны 17.06-28.06.2024 Тема: Профориентация.",
      text: "Были невероятные дни для детей возраста 7+ с полноценными обедами и программами.",
       category:  { label: "Детские Форматы", href: "/vacation" },
    },
    {
      id: 17,
      image: june,
      title: "Событие, которое состоялось в честь Дня Защиты Детей 1 июня 2023 года.",
      text: "Приятный день с пользой для семьи! Мы познакомим вас с концепцией нашего центра, вы и ваш ребенок может поучаствовать в любом из направлений, которые предлагаем, вы познакомитесь с нашими чуткими преподавателями. ВХОД: свободный.",
      category:  { label: "Детские Форматы", href: "/vacation" },
    },
  ];

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const filteredPosts = posts.filter(post => {
    const matchCategory = selectedCategory === 'Все категории' || post.category.label === selectedCategory || post.category.labelTwo === selectedCategory;
    const matchKeyword = post.title.toLowerCase().includes(searchKeyword.toLowerCase()) || post.text.toLowerCase().includes(searchKeyword.toLowerCase());
    return matchCategory && matchKeyword;
  });

  return (
    <div className="">
      <br />
      <div className="container pt-5 pb-lg-5 pb-md-4 pb-2 my-5">
        {/* Page title + filters */}
        <div className="row align-items-center gy-2 mb-4 pb-1 pb-sm-2 pb-lg-3">
          <div className="col-lg-5">
            <h1 className="mb-lg-0">Блог & Новости</h1>
          </div>
          <div className="col-lg-7 d-flex align-items-center justify-content-end gap-3">
         <a className="text-nav btn btn-icon bg-light border rounded-circle p-2" href="/" databstoggle="tooltip" dataBsPlacement="left" title="Back to home"><i className="ai-home"></i></a>
         </div>
          <div className="col-xl-3 offset-xl-1 col-lg-3 col-sm-5">
            <select className="form-select" value={selectedCategory} onChange={handleCategoryChange}>
              <option>Все категории</option>
              <option>Детские Форматы</option>
              <option>Бизнес Форматы</option>
              <option>Взрослые Форматы</option>
              <option>Связаться с нами</option>
              <option>Путешествие</option>
              {/* <option>Путешествие &amp; Коникулы</option> */}
            </select>
          </div>
          <div className="col-lg-4 col-sm-7">
            <div className="position-relative flex-grow-1 fs-5">
              <i className="ai-search position-absolute top-50 start-0 translate-middle-y ms-3"></i>
              <input
                className="form-control ps-5 fs-lg"
                type="search"
                placeholder="Введите ключевое слово"
                value={searchKeyword}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>

        {/* Posts rendering */}
        {filteredPosts.length > 0 ? (
          filteredPosts.map(post => (
            <article className="row g-0 border-0 pt-3 pt-sm-0 mb-4" key={post.id}>
              <img
                className="col-sm-5 col-lg-4 bg-repeat-0 bg-size-cover bg-position-center rounded-5 img-fluid blog-img"
                src={post.image}
                alt={post.title}
              />
              <div className="col-sm-7 col-lg-8">
                <div className="pt-4 pb-sm-4 ps-sm-4 pe-lg-4">
                  <h3><a href="/">{post.title}</a></h3>
                  <p className=" d-md-block">{post.text}</p>
                  {post.bulletPoints && (
                    <div>
                      <strong>Разберем такие важные темы как:</strong>
                      <ul>
                        {post.bulletPoints.map((point, index) => (
                          <li key={index}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <p className=" d-md-block">{post.textNext}</p>
                  <p className=" d-md-block">{post.texts}</p>
              <div className="d-flex flex-wrap align-items-center mt-n2">
          {/* <a className="nav-link text-muted fs-sm fw-normal p-0 mt-2 me-3" href="/">
            10<i className="ai-share fs-lg ms-1"></i>
          </a> */}
          {/* Share on Telegram */}
          <a 
            className="nav-link text-muted fs-sm fw-normal p-0 mt-2 me-3" 
            href={`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(post.title)}`} 
            target="_blank" 
            rel="noopener noreferrer"
          >
           Telegram <i className="ai-share fs-lg ms-1"></i>
          </a>
          {/* Share on VK */}
          <a 
            className="nav-link text-muted fs-sm fw-normal p-0 mt-2 me-3" 
            href={`https://vk.com/share.php?url=${encodeURIComponent(window.location.href)}`} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            VK  <i className="ai-share fs-lg ms-1"></i>
          </a>
          <span className="fs-xs opacity-20 mt-2 mx-3">|</span>
          <a className="badge text-nav fs-xs border mt-2" href={post.category.href}>
            {post.category.label}
          </a> 
          <a className="badge text-nav fs-xs border mt-2" href={post.category.href}>
            {post.category.labelTwo}</a>
         </div>
        </div>
       </div>
      </article>))
        ) : (
          <p>Ничего не найдено.</p>
        )}
      </div>
    </div>
  );
};

export default Blog;